import { pick } from 'ramda';

const defaultProps = [
  'autocomplete',
  'autofocus',
  'dirname',
  'disabled',
  'form',
  'formnovalidate',
  'list',
  'max',
  'maxLength',
  'min',
  'multiple',
  'name',
  'pattern',
  'placeholder',
  'readonly',
  'required',
  'size',
  'step',
  'type',
  'value',
];

const byType: Record<string, string[]> = {
  file: ['accept'],
  checkbox: ['checked'],
  radio: ['checked'],
  submit: ['formaction', 'formenctype', 'formmethod', 'formtarget'],
  image: [
    'alt',
    'formaction',
    'formenctype',
    'formmethod',
    'formtarget',
    'height',
    'src',
    'width',
  ],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sanitizeProps = (props: Record<string, any>): Record<string, any> => {
  const { type, ...rest } = props;
  return {
    ...pick(defaultProps, { type, ...rest }),
    ...(byType[type] && pick(byType[type], rest)),
  };
};

export default sanitizeProps;
